module.exports = __webpack_public_path__ + "static/media/create-your-match-icon.c2284f58.svg";